import type { SystemStyleObject, Theme } from '@mui/system'

// portal page 内 text style の SSoT.
// docs/design-system/03 §3.2 の 10 tier に portal 用の役割を割当.
// raw <Typography sx={{ fontSize: ... }}> の散らかりを集約.
export const PORTAL_TEXT: Record<string, SystemStyleObject<Theme>> = {
  pageTitle: {
    fontSize: 20,
    fontWeight: 600,
    color: 'text.primary',
    letterSpacing: 0.2,
  },
  sectionHeading: {
    fontSize: 13,
    fontWeight: 600,
    color: 'text.primary',
    letterSpacing: 0.2,
  },
  sectionDesc: {
    fontSize: 12,
    color: 'text.secondary',
    lineHeight: 1.6,
  },
  rowLabel: {
    fontSize: 14,
    fontWeight: 500,
    color: 'text.primary',
  },
  rowDesc: {
    fontSize: 12,
    color: 'text.secondary',
    lineHeight: 1.6,
  },
  cellBody: {
    fontSize: 14,
    color: 'text.primary',
  },
  cellSecondary: {
    fontSize: 13,
    color: 'text.secondary',
  },
  cellMeta: {
    fontSize: 12,
    color: 'text.secondary',
  },
  empty: {
    fontSize: 13,
    color: 'text.secondary',
  },
  emptyHint: {
    fontSize: 12,
    color: 'text.secondary',
  },
  errorInline: {
    fontSize: 13,
    color: 'error.main',
  },
  caption: {
    fontSize: 12,
    color: 'text.secondary',
    lineHeight: 1.6,
  },
  badge: {
    fontSize: 12,
    fontWeight: 500,
    color: 'text.primary',
  },
  kpiTitle: {
    fontSize: 12,
    color: 'text.secondary',
  },
  kpiValue: {
    fontSize: 24,
    fontWeight: 600,
    color: 'text.primary',
    lineHeight: 1.2,
  },
  kpiUnit: {
    fontSize: 13,
    color: 'text.secondary',
    fontWeight: 400,
  },
}
